var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"pa-0 ma-0"},[(_vm.isLoading)?_c('LoadingView',{staticStyle:{"position":"absolute","top":"0"}}):_vm._e(),_c('div',{attrs:{"id":"app"}},[_c('router-view'),_c('footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }